module.exports = "<button class=\"info\" (click)=\"toggleVisibility()\" aria-label=\"information\"><span class=\"icon icon-info-circle\"></span></button>\r\n<div class=\"info-content text-center\" [attr.aria-hidden]=\"!tag.tooltipOpen\" role=\"tooltip\" [class.show]=\"tag.tooltipOpen\" [id]=\"'tooltip-'+tag.id\">\r\n    {{ tag.tooltip }}\r\n    <button class=\"close\" (click)=\"toggleVisibility()\" aria-label=\"close tooltip\"><span class=\"icon icon-close\"></span></button>\r\n</div>  "


//////////////////
// WEBPACK FOOTER
// C:/dev/um.stamps/src/app/shared/tooltip/tooltip.component.html
// module id = ../../../../../src/app/shared/tooltip/tooltip.component.html
// module chunks = main